import { voltFetch } from "../voltApi";

export type GoogleConnection = {
  connected: boolean;
  googleEmail: string | null;
  scopes: string[];
  missingScopes: string[];
};

// The account is the signed-in one (bearer token); the server takes no user id.
export const googleConnectionApi = {
  status: () => voltFetch<GoogleConnection>("/gmail/connection"),
  start: () =>
    voltFetch<{ url: string }>("/gmail/connection", { method: "POST" }),
  // Second half of the consent: the server stores the grant only if this login started it.
  confirm: (body: { code: string; state: string }) =>
    voltFetch<GoogleConnection>("/gmail/connection/confirm", {
      method: "POST",
      body: JSON.stringify(body),
    }),
  disconnect: () =>
    voltFetch<{ connected: false; revoked: boolean; deleted: boolean }>(
      "/gmail/connection",
      { method: "DELETE" },
    ),
};

// Leaving the Hub for Google's consent page; an object so tests can stub it.
export const browser = {
  open: (url: string) => window.location.assign(url),
};
